export const getFormattedSortCode = (sortCode?: string | null) => {
  if (!sortCode) {
    return null;
  }

  return sortCode.replace(/(\d{2})(?=\d)/g, '$1-');
};
